{
  "newFeature": "간소화된 애플리케이션 스위처에는 이제 단일 목록에서 사용 가능한 앱만 포함됩니다.",
  "newLayout": "새로운 레이아웃",
  "ok": "확인"
}
